import { render, staticRenderFns } from "./ModuleHover.vue?vue&type=template&id=d7b0852a&scoped=true&"
import script from "./ModuleHover.vue?vue&type=script&lang=js&"
export * from "./ModuleHover.vue?vue&type=script&lang=js&"
import style0 from "./ModuleHover.vue?vue&type=style&index=0&id=d7b0852a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7b0852a",
  null
  
)

export default component.exports